module.exports = __webpack_public_path__ + "static/media/HCMM671.1aff9080.jpg";